import * as d3 from 'd3';


import deslug from '@/utils/deslug'

function slugify(string) {

    if (string) return string
        .toString()
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^\w\-]+/g, "")
        .replace(/\-\-+/g, "-")
        .replace(/^-+/, "")
        .replace(/-+$/, "");
}

function toTitleCase(str) {
    return str.replace(/_/g, ' ')
        .replace(/\w+/g, function(txt){ return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
}




var scatterplot = function(opts) {

    //data, datasegment, and groupvar can be passed from scatterset parent object.
    // of course, you can just call scatterplot on its own too.
  
  
    this.data = opts.data;
    
    //built so we can pass a dictionary with many different values. groupvar is just the value that signifies how the points should be categorized.
    // one point in the chart for each stationvar.
    this.groupvar = opts.groupvar;
    //focusvar is the value that should be mapped on the x axis.
    this.focusvar = opts.focusvar;

    this.bindpoint = opts.bindTo;
    
    this.bindDescriptionTo = opts.bindDescriptionTo;

    this.dotradius = 4;
    this.dotheight = 39;
    this.dotstep = 1.8;
    this.labelheight = 33;
    this.axisheight = 50;
    this.scalepow = 1;

    this.fixscales = false; //variable used to determine whether or not we should fix the scales to the largest extent in the data set.
                            // if false, scales regenerate with each new dataset passed

	
		console.log("BIND DESCRIPTION TO", this.bindDescriptionTo)
	
    //groups to filter out of the chart
    this.filteritems = opts.filter || [];

    //creation of basic elements for binding the instance.
    this.svg = d3.select(this.bindpoint).append('svg')
                .attr("preserveAspectRatio", "xMinYMin meet")
                .attr("viewBox", "0 0 500 75")
                .classed("svg-content", true)
                .html('<h1>' + this.focusvar + '</h1>');

    //group we use to append the dots to
    this.stationgroup = this.svg.append('g')
                .attr('class', 'stations')
                .attr('transform', 'translate(25, 0)');

    this.setColorScales();

    // limit the data to just one segment if we are passed a dictionary, remove all the items that don't have a value.
    // assigning to this.chartdata is identity, and only there for clarity. this.cleanData() sets the variable.
    this.chartdata = this.cleanData();
    this.draw(this.chartdata);

}


scatterplot.prototype.tickValues = function (extent) {
    var min = extent[0],
        max = extent[1],
        q = (max - min) / 4,
        q1 = min + q * 1,
        q2 = min + q * 2,
        q3 = min + q * 3;

    return [min, q1, q2, q3, max];
}



//we only set color once, based on all attributes, so it doesn't change on update.

scatterplot.prototype.setColorScales = function() {
    //get array of all possible groups in the dataset
    var _this = this;
    var groups = [];
    
    _this.data.forEach(function(d) {
        groups.push(d[_this.groupvar])
    })
  
    groups = d3.set(groups).values().sort();
    

    this.stationColor = d3.scaleOrdinal()
        .domain(groups)
        .range(d3.schemeCategory10);
}

scatterplot.prototype.setScales = function (data) {
    var _this = this;
    //dont change this without also changing legend function scale

    this.x = d3.scalePow()
        .exponent(_this.scalepow)
        .range([0, 450]) //leave five padding on both sides.
        .clamp(true);

    /*
    / if there is a datasegment, we assume that the data is returning multiple segements
    that can be transformed via buttons above the graph.
    We want these transitions to be useful to the user, so we fix scale to the largest extent so people can see the difference.

    Remember that the first segment is operating on the full, complex dictionary: _this.data, white the second datasegment
    is operating on the simplified two item dictionary defined in cleanData().

    */
    
    
        this.focusExtent = d3.extent(this.chartdata.map(function (d) {
            return d.value
        }));
    // }
  
  
  
    _this.x.domain(this.focusExtent);

}



/*
D3 struggle with updates if we change the assigned key.
e.g. will not match if we alter d['groupvar']

get around this problem by simplifying chartdata into
[{group: x, value:x}, {group: x, value:x}} format

 */


/*

FILTER IS ONLY USED ON THE FINAL CHART DATA DICTIONARY.
it is reliant on the this.filteritems array, which filters out groups we do not want to see.
 */

scatterplot.prototype.cleanData = function () {
    var _this = this;
    
    //pull only data segment if defined
  
     //filter through array! this is no longer a key.
    var cleandata = this.data;

    //splice out elements where group is not defined, convert value to float.
    cleandata.forEach(function (d, i) {
        try {
            if (!d[_this.groupvar]) {
                cleandata.splice(i, 1);  // if we can't categorize it, get rid of it.
            }
            d[_this.focusvar] = parseFloat(Number(d[_this.focusvar]).toFixed(2));
        } catch (e) {
            console.warn(e);
        }
    })


  

    //we need to filter out the values in the data that don't correspond to the metric we are mapping.
    //the "label" value of each dictionary should contain the name of the attribute we are looking for.
    // we then map to a simple dictionary... bit of legacy code. Could refactor to make it run off current dictionary.
    this.chartdata = cleandata.filter((d) => d.label === _this.focusvar)
        .map(function (d) { return {'group': d[_this.groupvar], 'value': d.value} })
  
  
    //filter out user set items
  console.log("FILTER ITEMS", _this.filteritems);
    console.log(this.chartdata, this.chartdata.length)
    this.chartdata = this.chartdata.filter(d => !_this.filteritems.includes(d.group));
    console.log(this.chartdata.length)
    return this.chartdata;
}


scatterplot.prototype.draw = function () {

    var _this = this;
    
    
    const data = this.chartdata;
    this.setScales(data);
    this.updateAxes();

    //function to find circles that overlap.
    //then we create y-scale to stack.

    var xar = data.map(function (d) {
        return _this.x(d.value)
    })
        .sort(function (a, b) {
            return a - b;
        });


    //this piece of code applies y-scaling to points that overlap.
    data.forEach(function (d, i) {
        d.xpos = _this.x(d.value);
        var aridx = xar.indexOf(d.xpos);
        var yidx = 0;
        for (i = aridx - 1; i >= 0; i--) {
            if (xar[aridx] - xar[i] < 2) {
                yidx += 1;
            }
            else {
                break;
            }
        }
        d.yidx = yidx;
    });

    var y = function (step) {
        return _this.dotheight - (_this.dotstep * step);
    };
    
    
    var groups = _this.stationgroup.selectAll('g.station')
        .data(data, function (d) { return d.group})
  
  
  console.log("gropus", groups)

    groups
        .selectAll('circle')
        .data(data, function (d) { return d.group})
        .transition().duration(500)
        .attr('cx', function (d) {
            return d.xpos
        })
        .attr('cy', function (d) {
            return y(d.yidx);
        });



    groups.exit()
        .attr('opacity', 1)
        .transition()
        .duration(500)
        .attr('opacity', 0)
        .remove();

    var newstations = groups.enter()
        .append('g')
        .attr('class', 'station');


    var newcircles = newstations
        .append('circle')
        .attr('class', function (d) {
            return 'station-circle-' + slugify(d.group)
        })
        .attr('station', function (d) {
            return d.group
        })
        .attr('realname', function (d) {
            return d['station_realname']
        })
        .attr('r', 4)
        .attr('cx', function (d) {
            return 0  //initialize value to 0 for animation
        })
        .attr('cy', function (d) {
            return y(d.yidx);
        })
        .attr('fill', function (d, i) {
            return _this.stationColor(d.group)
        })
        .attr('opacity', 1)// needed for update after filtering
        .attr('fill-opacity', .7)
        .attr('stroke-width', .3)
        .attr('stroke', function (d, i) {
            return d3.hsl(_this.stationColor(d.group)).darker(1)
        });
	
    
  newcircles.on('mousein', function(d) {
  	d3.select(_this.bindDescriptionTo)
			  .text(d.group)
  })
	
	newcircles
			.transition()
			.duration(900)
			.attr('cx', function (d) {
				return d.xpos
			})


    groups = groups.merge(newstations)

    _this.svg.selectAll('.circlelabel').remove();

    groups
        .append('text')
        .attr('class', function (d) {
            return 'station-circle-' + slugify(d.group)
        })
        .classed('circlelabel', true)
        .attr('opacity', 0)
        .attr('x', function (d) {
            return d.xpos
        })
        .attr('y', function (d) {
            return y(d.yidx);
        })
        .attr('dx', 3)
        .attr('dy', -4)
        .attr('opacity', 0)
        .text(function(d) { return d.value })





} //update


scatterplot.prototype.setAxes = function() {
    var _this = this;

    _this.axisgroup = _this.svg.append('g')
        .attr('class', 'axis-x')
        .attr('transform', 'translate(25,' + _this.axisheight + ')')


    _this.axisgroup.call(_this.axis);

}

scatterplot.prototype.updateAxes = function() {
    var _this = this;

    _this.axis = d3.axisBottom(_this.x).tickValues(_this.tickValues(_this.focusExtent))
        .tickSizeInner(0).tickSizeOuter(-3).tickPadding(3);

    if (_this.axisgroup) {
        _this.axisgroup.transition().duration(500).call(_this.axis)
    } else {
        _this.setAxes();
    }
}





scatterplot.prototype.update = function (opts) {
    var _this = this;

    if (!opts || typeof opts !== "object") opts = {};

    //check to see if the keys in the object match keys in opts.
    //if so, update object keys to opts values
    var existingkeys = Object.keys(_this);
    var optskeys = Object.keys(opts)
    optskeys.forEach(function (k) {
        if (existingkeys.indexOf(k) > -1) {
            _this[k] = opts[k];
        }
    })

    if (opts.filter && typeof opts.filter === "object") {
        _this.filteritems = _this.filteritems.concat(opts.filter)
    }
    if (opts.filter && typeof opts.filter === "string") {
        _this.filteritems.push(opts.filter);
    }



    //find duplicate filters and remove all instance from array, creating a toggle effect

        _this.filteritems.forEach(function (d, i) {
            // Find if there is a duplicate or not
            if (_this.filteritems.indexOf(d, i + 1) > -1) {
                //remove from array if so.
                _this.filteritems = _this.filteritems.filter(function(el) { return el != d })
            }
        });


    //unfix scales if no filtering.

    _this.fixscales =  !_this.filteritems.length;
    
    //check to see if opts has a filter func that needs to get passed to clean data.
    _this.cleanData();
    _this.draw();

    return _this;

}



/*
* END OF THE SCATTERPLOT SEGMENT
 */


/*
* OF COURSE, THE WHOLE POINT IS TO SHOW GROUPS OF SCATTERPLOTS TOGETHER!
* SO WE ARE GOING TO TO IMPLEMENT THIS WITH SCATTERPLOT SET
 */

/*

OPTS ARGUMENT IS PASSED TO THE SCATTERSET FUNCTION IN THE FOLLOWING MANNER:

{
    data: {} || []
    datasegment: the key of the correct array if data is dictionary. if not present, data must array.
    groupvar: the variable you would like to group by
    bindLegendTo: where to put the legend,
    legendlinkfactory: function that takes the name of the station as an argument and returns the link as attribute.
    //above is not totally abstracted. see if (this.legendlinkfactory) clause for implementation.

    scatterplots: {
        plotname1: {
            focusvar: data you want displayed as value,
            bindTo: '#chart'
        },
        plotname2: {
            focusvar: data you want displayed as value,
            bindTo: '#chart'
        },
    }

}


 */



var scatterSet = function (opts) {
    // these three data points are passed as the same variable to the children class.
    this.data = opts.data;
    this.masterData = opts.data;
    this.opts = opts;
    this.filterset = [];
    
    console.log("scatterdata", this.data);
    //built so we can pass a dictionary with many different values. Stationvar is just the value that signifies how the points hsould be categorized.
    // one point in the chart for each stationvar.
    this.groupvar = opts.groupvar;
    
    this.scatterplots = opts.scatterplots;

    //array of scatterplot objects we loop over to update.
    this.activeplots = [];
    
    //legend settings
    this.dotradius =  5;
    this.svgheight= 26;
    this.svgoffset = 8;

    this.legendlinkfactory = opts.legendlinkfactory,
    this.legend = d3.select(opts.bindLegendTo);
    
    this.chartField = d3.select(opts.bindTo)
  
    this.bindDescriptionTo = opts.bindDescriptionTo;
    this.create();
    this.updatelegend();
}


scatterSet.prototype.create = function() {
     var _this = this;
     //
     // Object.keys(_this.scatterplots).forEach(function(k) {
     //     var d = _this.scatterplots[k];
     //      d.data = _this.data;
     //      d.datasegment = _this.datasegment;
     //      d.groupvar = _this.groupvar;
     //
     //      var scatter = new scatterplot(d);
     //      _this.activeplots.push(scatter);
     //
     // })
     //
	const charts = _this.chartField.
  selectAll('.scatterplot').data(this.scatterplots, d => { return d.focusvar})
 
 
	const newcharts = charts
			.enter()
			.append('div')
      .classed('scatterplot', true)
      .attr('id', d => d.focusvar)
      .html((d) => '<h3 class="chart-title">' + deslug(d.focusvar) + '</h3>')
      
  
  newcharts
			.each(d => {
				d.data = _this.data;
				d.groupvar = _this.groupvar;
				d.bindTo = '#' + d.focusvar;
				d = {..._this.opts, ...d};
				let scatter = new scatterplot(d);
				_this.activeplots.push(scatter);

			})
  
  
  charts
      .exit()
      .style('opacity', 1)
        .transition()
        .duration(800)
        .style('opacity', 0)
      .remove();
  
  

    if (_this.activeplots.length) this.updatelegend();
    _this.strobeStation();

}


scatterSet.prototype.update = function(opts) {

    this.scatterplots = opts.scatterplots;
    
    this.create(opts);
    
    var _this = this;
    _this.activeplots.forEach(function(scatterobj) {
        //this is the scatterplot object in the array, not the scatterset prototype!
        
      console.log("opts", opts)
         scatterobj.update(opts);
     })

    _this.updatelegend();
    _this.strobeStation();
}


// scatterSet.prototype.filter = function() {
//     const _t = this;
//     this.data = this.masterData.filter(d => !_t.filterset.includes(d.name))
//
// }


///DATA HERE IS DEPENDENT ON ACTIVE PLOT VARIABLE BEING POPULATED.
// WE USE THE FIRST ELEMENT IN THE ARRAY TO GRAB CHART DATA AND MAINTAIN STATE.

scatterSet.prototype.updatelegend = function () {
	
	var _this = this;
	
	//data and station color taken from first scatterplot in array.
	
	
	function getData() {
		let groupset = []
		_this.activeplots.forEach(g => {
			groupset = [...groupset, ...g.data.map(d => {
				return {name: d.name, slug: d.slug}
			})]
		})
		
		
		const map = new Map();
		const result = [];
		
		for (const item of groupset) {
			if (!map.has(item.slug)) {
				map.set(item.slug, true);    // set any value to Map
				result.push({
					slug: item.slug,
					name: item.name
				});
			}
		}
		
		return result;
		
	}
	
	var data = getData();
	var stationColor = _this.activeplots[0].stationColor;
	
	
	_this.legend.html('');
	var tablehtml = "";
	
	data.forEach(function (d) {
		
		var station = d.slug,
				displayname = d.name,
				stationcolor = stationColor(d.name);
		
		
		var realname = displayname;
		
		tablehtml += "<div uk-tooltip=\"title:" + realname + "; pos: top\"" +
        "class='scatterplot-legend-item station-circle-" + station + "' station =\"" + station + "\" realname=\"" + realname + "\" filterhandle=\"" + station + "\">" +
				"<svg width = '" + (_this.svgheight) + "' height = '" + _this.svgheight + "'>" +
				"<circle class='station-circle-" + station + "'r='" + _this.dotradius + "'' fill='" + stationcolor + "' fill-opacity='0.7' stroke='" + d3.hsl(stationcolor).darker() + "' transform = 'translate(" + _this.svgoffset + "," + _this.svgoffset + ")'></circle></svg> "
				+ "<a href='" + _this.legendlinkfactory(station) + "'><span class = 'stationname'>" + displayname + "</span></a><span class = 'filterbutton'>X</span></div>"
	})

    tablehtml += "</tr>";

    _this.legend.html(tablehtml);



    //control strobing and interactivity of legend elements

    _this.legend.selectAll('.scatterplot-legend-item').on('mouseover', function () {
        var t = d3.select(this);
        t.style('font-weight', '800');
        var stationclass = 'station-circle-' + t.attr('station');
        var station = t.attr('station');
        d3.select('.unit-preview').style('opacity', 1).html(function(){
            var realname = t.attr('realname')
            return realname ? realname.toUpperCase() : station.toUpperCase()
        })
        _this.strobeCircle(stationclass);
    });

    
    _this.legend.selectAll('.scatterplot-legend-item').on('mouseout', function () {
        var t = d3.select(this);
        t.style('font-weight', 'unset');
        var stationclass = 'station-circle-' + t.attr('station');
        var station = t.attr('station');
        d3.select('.unit-preview').style('opacity', 0);
        _this.endStrobe(stationclass);
    });
	
	
	_this.legend.selectAll('.filterbutton').on('click', function () {
		var parent = d3.select(this.parentNode)
		parent.classed('filtered', !parent.classed('filtered'));
		
		_this.activeplots.forEach(function (scatterobj) {
			//this is the scatterplot object in the array, not the scatterset prototype!
			scatterobj.update({filter: parent.attr('filterhandle')}, false); // false = don't reset legend.
		})
  
	})
 

}




scatterSet.prototype.strobeCircle = function (stationclass) {
    let c = d3.selectAll('circle.' + stationclass);
    d3.selectAll('text.' + stationclass).style('opacity', 1);

    c.each(function () {
        parent = d3.select(this).node().parentNode;
        parent.append(this);
    });

    c.attr('stroke-width', 1);
    (function strobe() {
        c.transition()
            .duration(1000)
            .attr('r', 7)
            .transition()
            .attr('r', 6)
            .duration(1000)
            .on('end', strobe)
    })();

}


scatterSet.prototype.endStrobe = function (stationclass) {
        var _this = this;
        d3.selectAll('text.' + stationclass).style('opacity', 0);
        d3.selectAll('circle.' + stationclass)
            .attr('stroke-width', '0.2')
            .transition()
            .attr('r', _this.dotradius);
    }


scatterSet.prototype.strobeStation = function () {
    var _this = this;

    d3.selectAll('.station').selectAll('circle')
        .on('mouseover', function () {
            var t = d3.select(this),
                tclass = t.attr('class');
            _this.strobeCircle(tclass);
            d3.selectAll(_this.bindDescriptionTo).style('opacity', 1).html(function () {
                var realname = t.attr('realname');
                return realname ? realname : t.attr('station');
            });
            d3.select('div.' + tclass).style('font-weight', 800);
        })
        .on('mouseout', function () {
            var t = d3.select(this),
            tclass = t.attr('class');
            _this.endStrobe(tclass);
            d3.selectAll(_this.bindDescriptionTo).style('opacity', 0);
            d3.select('div.' + tclass).style('font-weight', 'unset');
        });
}








export default scatterSet;






